// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__5m9Ql","title":"ClientReferral_title__2yNNQ","itemText":"ClientReferral_itemText__3rb_k"};